/** Réglages des fonds du thème Arcade (voir ../reglages.js pour la description des types). */
export const REGLAGES = {
    vitesse: {
        type: "nombre", libelle: "Vitesse de l'animation", min: 0.5, max: 2, pas: 0.1, defaut: 1, unite: "×",
        aide: "×1 est la vitesse d'origine.",
    },
    nombre: {
        type: "nombre", libelle: "Nombre d'éléments", min: 4, max: 24, pas: 1, defaut: 12,
        aide: "Extraterrestres, blocs ou lignes de texte selon le fond (24 au plus, pour garder l'écran léger).",
    },
    couleurs: {
        type: "choix", libelle: "Palette", defaut: "neon",
        options: [{valeur: "neon", libelle: "Néon (violet, cyan, rose)"}, {valeur: "ambre", libelle: "Écran ambre"}, {valeur: "vert", libelle: "Écran vert"}],
    },
};

/** Couleurs de chaque palette : fond, deux nuances de fond, trois couleurs vives. */
export const PALETTES = {
    neon: {fond: "#12002b", fond2: "#2a0a55", vives: ["#00e5ff", "#ff3fa4", "#b8ff3f"]},
    ambre: {fond: "#1a0f00", fond2: "#3a2200", vives: ["#ffb000", "#ff8a00", "#ffd966"]},
    vert: {fond: "#001a08", fond2: "#00381a", vives: ["#33ff66", "#8dff9f", "#00c44a"]},
};
